import {
  FETCH_DASHBOARD_DATA_REQUEST,
  FETCH_DASHBOARD_DATA_SUCCESS,
  FETCH_DASHBOARD_DATA_FAILURE,
  FETCH_VENDOR_DASHBOARD_DATA_REQUEST,
  FETCH_VENDOR_DASHBOARD_DATA_SUCCESS,
  FETCH_VENDOR_DASHBOARD_DATA_FAILURE,
  FETCH_CUSTOMER_DASHBOARD_DATA_REQUEST,
  FETCH_CUSTOMER_DASHBOARD_DATA_SUCCESS,
  FETCH_CUSTOMER_DASHBOARD_DATA_FAILURE,
} from "./DashboardType";

export const fetchDashboardDataRequest = () => ({
  type: FETCH_DASHBOARD_DATA_REQUEST,
});

export const fetchDashboardDataSuccess = (data) => ({
  type: FETCH_DASHBOARD_DATA_SUCCESS,
  payload: data,
});

export const fetchDashboardDataFailure = (error) => ({
  type: FETCH_DASHBOARD_DATA_FAILURE,
  payload: error,
});
export const fetchVendorDashboardDataRequest = () => ({
  type: FETCH_VENDOR_DASHBOARD_DATA_REQUEST,
});

export const fetchVendorDashboardDataSuccess = (data) => ({
  type: FETCH_VENDOR_DASHBOARD_DATA_SUCCESS,
  payload: data,
});

export const fetchVendorDashboardDataFailure = (error) => ({
  type: FETCH_VENDOR_DASHBOARD_DATA_FAILURE,
  payload: error,
});

export const fetchCustomerDashboardDataRequest = () => ({
  type: FETCH_CUSTOMER_DASHBOARD_DATA_REQUEST,
});

export const fetchCustomerDashboardDataSuccess = (data) => ({
  type: FETCH_CUSTOMER_DASHBOARD_DATA_SUCCESS,
  payload: data,
});

export const fetchCustomerDashboardDataFailure = (error) => ({
  type: FETCH_CUSTOMER_DASHBOARD_DATA_FAILURE,
  payload: error,
});
